import React from 'react';
import { Flex } from 'rebass';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { AssignmentStatus } from '../../../../types/assignment';
import {
  FormComboGroup,
  Input,
  SearchInput,
  Select,
} from '../../../../components/Form';
import Button from '../../../../components/Button/Button';
import { rebassProps } from '../../../../theme/theme';
import { FilterBarProps } from '../../../../components/FilterBar/FilterBar';
import { JobStatusPicker } from '../../../../components/Job/JobStatusPicker';
import { getStringSearchPlaceholder } from '../../../../helpers/search';

const resultOptions = [
  {
    value: 'ALL',
    label: '- result -',
  },
  {
    value: 'PASS',
    label: 'Pass',
  },
  {
    value: 'FAIL',
    label: 'Fail',
  },
  {
    value: 'FAILPASS',
    label: 'Fail/Pass',
  },
];

export const stringSearchFields = [
  {
    field: 'id',
    label: 'Job',
  },
  {
    field: 'address.street1',
    label: 'Address',
  },
  {
    field: 'address.street2',
    label: null,
  },
  {
    field: 'recycledWaterInspection.waterSite.name',
    label: 'Site',
  },
  {
    field: 'recycledWaterInspection.contact.name',
    label: 'Contact',
  },
  {
    field: 'recycledWaterInspection.supervisor.name',
    label: 'Supervisor',
  },
];

export const dateOptions = [
  {
    field: 'created',
    label: 'Ordered',
  },
  // {
  //   field: 'assigned',
  //   label: 'Assigned',
  // },
  // {
  //   field: 'completed',
  //   label: 'Completed',
  // },
  // {
  //   field: 'submitted',
  //   label: 'Submitted',
  // },
];

export type JobFilters = {
  status?: AssignmentStatus[];
  testResult?: string;
  stringSearch?: string;
  currentDateFilterField?: string;
  dateStart?: string;
  dateEnd?: string;
  flags?: string[];
};

export const defaultFilters: JobFilters = {
  status: ['OPEN'],
};

type FilterBarJobProps = FilterBarProps<JobFilters>;

const FilterBarJob: React.FC<FilterBarJobProps> = (props) => {
  const { filters, setFilters, selectedId } = props;

  const onChange = (e: any) => {
    setFilters((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <Flex variant="filterBar.container" {...(props as rebassProps)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(stringSearchFields)}
          autoFocus={isBrowser && !selectedId}
          width={300}
          name="stringSearch"
          value={filters.stringSearch || ''}
          onChange={onChange}
        />
        <JobStatusPicker
          value={filters.status}
          onChange={(values) => {
            setFilters({
              ...filters,
              status: values,
            });
          }}
        />
        <FormComboGroup>
          <Select
            name="currentDateFilterField"
            value={filters.currentDateFilterField || 'ALL'}
            onChange={onChange}
            variant={
              filters.currentDateFilterField &&
              filters.currentDateFilterField !== 'ALL'
                ? 'inputRoundedLeft'
                : 'input'
            }
            width={130}
          >
            <option value="ALL">- date -</option>
            {dateOptions.map((dateOption, i) => (
              <option value={dateOption.field} key={i}>
                {dateOption.label}
              </option>
            ))}
          </Select>
          {filters.currentDateFilterField &&
            filters.currentDateFilterField !== 'ALL' && (
              <>
                <Input
                  id="dateStart"
                  name="dateStart"
                  variant="inputSquare"
                  type="date"
                  width={150}
                  value={filters.dateStart || ''}
                  onChange={onChange}
                />
                <Input
                  id="dateEnd"
                  name="dateEnd"
                  type="date"
                  width={150}
                  variant="inputRoundedRight"
                  value={filters.dateEnd || ''}
                  onChange={onChange}
                />
              </>
            )}
        </FormComboGroup>
      </Flex>

      <Flex variant="filterBar.right">
        <Button
          variant="outline"
          icon="undo"
          onClick={() => setFilters(defaultFilters)}
          title="Reset Form"
        />
      </Flex>
    </Flex>
  );
};

FilterBarJob.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarJob;
